<template>
  <div>
    <v-container class="py-0 px-0" id="hide">
      <v-card tile>
        <v-card-text class="p-1">
          <h5>Detail Invoice</h5>

          <v-row class="mt-2">
            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-text-field
                label="No Pelunasan"
                dense
                hide-details
                disabled
                v-model="formData.no_pelunasan"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-text-field
                label="Tgl Pelunasan"
                type="date"
                dense
                hide-details
                v-model="formData.tgl_pelunasan"
                @change="updatePelunasanNota"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-autocomplete
                label="Ditagih Kepada"
                dense
                hide-details
                :items="items.customers"
                :loading="loading.fetchCustomers"
                :disabled="
                  loading.fetchCustomers ||
                    state.disable_change_customer ||
                    !formData.tgl_pelunasan
                "
                v-model="formData.ditagih_kepada"
                @change="
                  updatePelunasanNota();
                  fetchNota();
                "
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" sm="2" class="py-0">
              <v-autocomplete
                label="Kolektor"
                dense
                hide-details
                v-model="formData.kolektor"
                :items="items.kolektor"
                :loading="loading.fetchKolektor"
                :disabled="loading.fetchKolektor"
                @change="updatePelunasanNota"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" sm="4" class="py-0">
              <v-text-field
                label="Keterangan Pelunasan"
                type="text"
                dense
                hide-details
                v-model="formData.keterangan_pelunasan"
                @change="updatePelunasanNota"
              ></v-text-field>
            </v-col>
          </v-row>

          <table width="100%">
            <thead>
              <th>No Nota</th>
              <th>Tanggal</th>
              <th>Total Nota</th>
              <th class="text-center">Lunas</th>
            </thead>
            <tbody>
              <tr v-if="loading.fetchNota">
                <td colspan="6">
                  <v-text-field color="success" loading disabled></v-text-field>
                </td>
              </tr>
              <tr v-for="invoice in data.invoices" :key="invoice.id">
                <td>{{ invoice.nomor_nota }}</td>
                <td>{{ formatDate(invoice.tgl_nota) }}</td>
                <td>
                  {{
                    formatCurrency(
                      Math.abs(invoice.i_total) +
                        Math.abs(invoice.ii_total) +
                        Math.abs(invoice.biaya_lain_total)
                    )
                  }}
                </td>
                <td class="text-center">
                  <input
                    type="checkbox"
                    :id="invoice.nomor_nota"
                    :ref="invoice.nomor_nota"
                    :checked="invoice.lunas == 'Y'"
                    @change="setStatusLunas(invoice, $event.target.checked)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>

      <v-card tile>
        <v-card-text class="p-1">
          <h5>Pemotongan</h5>

          <v-row>
            <v-col cols="12" md="2" sm="2">
              <v-autocomplete
                label="No Nota"
                dense
                hide-details
                :items="items.nota"
                :loading="loading.fetchNota"
                :disabled="loading.fetchNota"
                v-model="claimFormData.nomor_nota"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Total Claim"
                type="text"
                dense
                small-chips
                hide-details
                v-model="totalClaim"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="No LK"
                type="text"
                dense
                small-chips
                hide-details
                v-model="claimFormData.no_laporan"
                @keydown.enter="checkNoLaporan"
                :loading="loading.findLaporan"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-autocomplete
                label="Kategori Claim"
                dense
                hide-details
                :items="items.kategoriClaim"
                :loading="loading.fetchKategoriClaim"
                v-model="claimFormData.kategori"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                label="Keterangan Claim"
                type="text"
                dense
                small-chips
                hide-details
                v-model="claimFormData.keterangan"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1" sm="1">
              <v-btn
                small
                color="primary"
                :loading="loading.addClaim"
                :disabled="loading.addClaim"
                @click="addClaim"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <table width="100%">
            <thead>
              <th>No</th>
              <th>No Nota</th>
              <th>No LK</th>
              <th>Total Claim</th>
              <th>Kategori</th>
              <th>Keterangan</th>
              <th class="text-center">Action</th>
            </thead>
            <tbody>
              <tr v-if="loading.fetchClaim">
                <td colspan="7">
                  <v-text-field color="success" loading disabled></v-text-field>
                </td>
              </tr>
              <tr v-for="(claim, i) in data.claims" :key="claim.id">
                <td>{{ i + 1 }}</td>
                <td>{{ claim.nomor_nota }}</td>
                <td>{{ claim.no_laporan }}</td>
                <td>{{ formatCurrency(claim.total) }}</td>
                <td>{{ claim.kategori }}</td>
                <td>{{ claim.keterangan }}</td>
                <td class="text-center">
                  <v-icon @click="deleteClaim(claim.id)">mdi-delete</v-icon>
                </td>
              </tr>
              <tr>
                <td colspan="3"><b>Total Nilai Claim</b></td>
                <td>
                  <b>{{ formatCurrency(totalNilaiClaim) }}</b>
                </td>
                <td colspan="3"></td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>

      <v-card tile>
        <v-card-text class="p-1">
          <h5>Giro</h5>

          <v-row>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Nama Bank"
                type="text"
                dense
                small-chips
                hide-details
                v-model="giroFormData.nama_bank"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Nomor Giro"
                type="text"
                dense
                small-chips
                hide-details
                v-model="giroFormData.nomor_giro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3" sm="3">
              <v-text-field
                label="Nominal Giro"
                type="text"
                dense
                small-chips
                hide-details
                v-model="totalGiro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Tgl Cair"
                type="date"
                dense
                small-chips
                hide-details
                v-model="giroFormData.tgl_cair"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1" sm="1">
              <v-btn
                small
                color="primary"
                :loading="loading.addGiro"
                :disabled="loading.addGiro"
                @click="addGiro"
                >Add</v-btn
              >
            </v-col>
          </v-row>
          <table width="100%">
            <thead>
              <th>No</th>
              <th>Nama Bank</th>
              <th>Nomor Giro</th>
              <th>Nominal</th>
              <th>Tgl Cair</th>
              <th>Action</th>
            </thead>
            <tbody>
              <tr v-if="loading.fetchGiro">
                <td colspan="6">
                  <v-text-field color="success" loading disabled></v-text-field>
                </td>
              </tr>
              <tr v-for="(giro, i) in data.giros" :key="giro.id">
                <td>{{ i + 1 }}</td>
                <td>{{ giro.nama_bank }}</td>
                <td>{{ giro.nomor_giro }}</td>
                <td>{{ formatCurrency(giro.nominal_giro) }}</td>
                <td>{{ formatDate(giro.tgl_cair) }}</td>
                <td>
                  <v-icon @click="deleteGiro(giro.id)">mdi-delete</v-icon>
                </td>
              </tr>
            </tbody>
          </table>

          <h3 class="mt-5">
            Terima Cash: {{ formatCurrency(subtotalPelunasan) }}
          </h3>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Pop Up fetch invoice data -->
    <FindNomorNota :openModal="!haveNomorNota" @close-modal="setInvoiceData" />

    <!-- Show Laporan Kejadian Info -->
    <ShowLaporanModal
      :openModal="showLaporanModal"
      :data="data.laporan"
      @close-modal="
        showLaporanModal = false;
        this.data.laporan = {};
      "
    />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="formatForm"
    >
      New
    </v-btn>

    <!-- Cancel Button -->
    <v-btn
      class="mx-2 btn-delete"
      fab
      dark
      right
      bottom
      fixed
      color="error"
      @click="cancelPelunasan"
      :loading="loading.cancelPelunasan"
      v-if="formData.no_pelunasan"
    >
      Cancel
    </v-btn>
  </div>
</template>

<script>
import axios, { Axios } from "axios";

export default {
  components: {
    ShowLaporanModal: () =>
      import("@/components/LaporanKejadian/ShowModal.vue"),
    FindNomorNota: () => import("@/components/Invoice/PelunasanModal.vue")
  },
  data() {
    return {
      haveNomorNota: false,
      showLaporanModal: false,
      state: {
        disable_change_customer: false
      },
      formData: {
        no_pelunasan: "",
        ditagih_kepada: "",
        tgl_pelunasan: "",
        kolektor: "",
        keterangan_pelunasan: ""
      },
      claimFormData: {
        total: "",
        nomor_nota: "",
        no_laporan: "",
        kategori: "",
        keterangan: ""
      },
      giroFormData: {
        nama_bank: "",
        nomor_giro: "",
        nominal_giro: "",
        tgl_cair: ""
      },
      loading: {
        fetchKolektor: false,
        fetchCustomers: false,
        fetchNota: false,
        fetchClaim: false,
        fetchGiro: false,
        addClaim: false,
        addGiro: false,
        findLaporan: false,
        cancelPelunasan: false,
        fetchKategoriClaim: false
      },
      items: {
        kolektor: [],
        nota: [],
        kategoriClaim: []
      },
      data: {
        claims: [],
        giros: [],
        invoices: [],
        laporan: {}
      },
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"],
      subtotal: 0
    };
  },
  computed: {
    totalClaim: {
      get() {
        return this.formatCurrency(this.claimFormData.total);
      },
      set(val) {
        return (this.claimFormData.total = this.convertToAngka(val));
      }
    },
    totalNilaiClaim() {
      let total = 0;
      this.data.claims.forEach(claim => {
        total += claim.total || 0;
      });
      return total;
    },
    totalGiro: {
      get() {
        return this.formatCurrency(this.giroFormData.nominal_giro);
      },
      set(val) {
        return (this.giroFormData.nominal_giro = this.convertToAngka(val));
      }
    },
    subtotalPelunasan() {
      let subtotal = 0;

      this.data.claims.forEach(claim => {
        subtotal += claim.total;
      });

      this.data.giros.forEach(giro => {
        subtotal += giro.nominal_giro;
      });

      // let subtotalNota = 0;
      // this.data.invoices.forEach(invoice => {
      //   const check
      //   if (document.getElementById(`${invoice.nomor_nota}`).checked) {
      //     subtotalNota +=
      //       invoice.i_total ||
      //       0 + invoice.ii_total ||
      //       0 + invoice.biaya_lain_total ||
      //       0;
      //   }
      // });

      return this.subtotal - subtotal;
    }
  },
  watch: {
    async subtotalPelunasan() {
      if (!this.formData.no_pelunasan) return;

      await axios
        .put(`kas/pelunasan-invoice`, {
          no_transaksi: this.formData.no_pelunasan,
          subtotal: this.subtotalPelunasan,
          kolektor: this.formData.kolektor
        })
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    }
  },
  methods: {
    async checkNoLaporan() {
      // this.loading.findLaporan = true;
      // await axios
      //   .get(`laporan-kejadian/${this.claimFormData.no_laporan}`)
      //   .then(res => {
      //     this.loading.findLaporan = false;
      //     if (!res.data.id) {
      //       alert("No Laporan Tidak Ditemukan");
      //       return;
      //     }
      //     this.data.laporan = res.data;
      //     this.showLaporanModal = true;
      //   })
      //   .catch(err => {
      //     this.loading.findLaporan = false;
      //     alert(err.response.data.message);
      //   });
    },
    async updatePelunasanNota() {
      await axios
        .put(
          `pelunasan/update?no_pelunasan=${this.formData.no_pelunasan}`,
          this.formData
        )
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async fetchKategoriClaim() {
      this.loading.fetchKategoriClaim = true;

      await axios
        .get(`master-data?kategori=kategori_tagihan`)
        .then(res => {
          this.items.kategoriClaim = res.data.map(item => item.nama);
          this.loading.fetchKategoriClaim = false;
        })
        .catch(err => {
          this.loading.fetchKategoriClaim = false;
        });
    },
    async fetchKolektor() {
      this.loading.fetchKolektor = true;

      await axios
        .get(`kolektor`)
        .then(res => {
          this.items.kolektor = res.data.map(item => ({
            text: item.nama,
            value: item.user_id
          }));

          this.loading.fetchKolektor = false;
        })
        .catch(err => {
          this.loading.fetchKolektor = false;

          alert(err.response.data.message);
        });
    },
    async fetchCustomers() {
      this.loading.fetchCustomers = true;

      await axios
        .get(`invoice/customers`)
        .then(res => {
          this.items.customers = res.data.map(item => ({
            text: `${item.nama} - ${item.kota} - ${item.alamat}`,
            value:
              item.status == "penerima"
                ? "PENERIMA-" + item.id
                : "PENGIRIM-" + item.id
          }));

          this.loading.fetchCustomers = false;
        })
        .catch(err => {
          this.loading.fetchCustomers = false;

          alert(err.response.data.message);
        });
    },
    async fetchNota() {
      this.loading.fetchNota = true;

      await axios
        .get(`pelunasan/nota?ditagih_kepada=${this.formData.ditagih_kepada}`)
        .then(res => {
          this.loading.fetchNota = false;

          this.data.invoices = res.data;
          const nomorNotaList = [...new Set(res.data.map(item => item.nomor_nota).filter(Boolean))];
          this.items.nota = nomorNotaList;
          if (this.items.nota.length > 0) {
            this.claimFormData.nomor_nota = this.claimFormData.nomor_nota || this.items.nota[0];
          }
        })
        .catch(err => {
          this.loading.fetchNota = false;

          alert(err.response.data.message);
        });
    },
    async fetchClaim() {
      this.loading.fetchClaim = true;

      await axios
        .get(`pelunasan/fetch-claim?no_pelunasan=${this.formData.no_pelunasan}`)
        .then(res => {
          this.data.claims = res.data;

          this.loading.fetchClaim = false;
        })
        .catch(err => {
          this.loading.fetchClaim = false;

          alert(err.response.data.message);
        });
    },
    async fetchGiro() {
      this.loading.fetchGiro = true;

      await axios
        .get(`pelunasan/fetch-giro?no_pelunasan=${this.formData.no_pelunasan}`)
        .then(res => {
          this.data.giros = res.data;

          this.loading.fetchGiro = false;
        })
        .catch(err => {
          this.loading.fetchGiro = false;

          alert(err.response.data.message);
        });
    },
    async setStatusLunas(invoice, value) {
      const status = value ? "Y" : "N";

      if (status == "Y") this.state.disable_change_customer = true;

      await axios
        .put(`invoice/update-status-lunas?nomor_nota=${invoice.nomor_nota}`, {
          no_pelunasan: this.formData.no_pelunasan,
          status_lunas: status,
          tgl_pelunasan: this.formData.tgl_pelunasan
        })
        .then(res => {
          if (status == "Y") {
            this.subtotal +=
              Math.abs(invoice.i_total) +
              Math.abs(invoice.ii_total) +
              Math.abs(invoice.biaya_lain_total);
          } else {
            this.subtotal -=
              Math.abs(invoice.i_total) +
              Math.abs(invoice.ii_total) +
              Math.abs(invoice.biaya_lain_total);
          }

          const nomorNotaList = [
            ...new Set((this.data.invoices || []).map(item => item.nomor_nota).filter(Boolean))
          ];
          this.items.nota = nomorNotaList;
          if (this.items.nota.length > 0) {
            this.claimFormData.nomor_nota = this.claimFormData.nomor_nota || this.items.nota[0];
          }
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async addClaim() {
      if (!this.claimFormData.nomor_nota) {
        alert("No Nota wajib diisi!");
        return;
      }
      this.loading.addClaim = true;

      await axios
        .post(
          `pelunasan/add-claim?no_pelunasan=${this.formData.no_pelunasan}`,
          this.claimFormData
        )
        .then(res => {
          this.claimFormData = {
            total: "",
            nomor_nota: "",
            no_laporan: "",
            kategori: "",
            keterangan: ""
          };

          this.fetchClaim();

          this.loading.addClaim = false;
        })
        .catch(err => {
          this.loading.addClaim = false;

          alert(err.response.data.message);
        });
    },
    async addGiro() {
      this.loading.addGiro = true;

      await axios
        .post(
          `pelunasan/add-giro?no_pelunasan=${this.formData.no_pelunasan}`,
          this.giroFormData
        )
        .then(res => {
          this.giroFormData = {
            nama_bank: "",
            nomor_giro: "",
            nominal_giro: "",
            tgl_cair: ""
          };

          this.fetchGiro();

          this.loading.addGiro = false;
        })
        .catch(err => {
          this.loading.addGiro = false;

          alert(err.response.data.message);
        });
    },
    async deleteClaim(id) {
      await axios
        .delete(`pelunasan/delete-claim/${id}`)
        .then(res => {
          this.fetchClaim();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async deleteGiro(id) {
      await axios
        .delete(`pelunasan/delete-giro/${id}`)
        .then(res => {
          this.fetchGiro();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    async cancelPelunasan() {
      let confirmation = confirm(
        "Apakah anda yakin ingin membatalkan pelunasan ini?"
      );

      if (!confirmation) return;

      this.loading.cancelPelunasan = true;

      await axios
        .put(
          `pelunasan/cancel-pelunasan?no_pelunasan=${this.formData.no_pelunasan}`
        )
        .then(res => {
          this.loading.cancelPelunasan = false;
          this.formatForm();
        })
        .catch(err => {
          this.loading.cancelPelunasan = false;
          alert(err.response.data.message);
        });
    },
    setInvoiceData(val) {
      this.haveNomorNota = true;

      this.formData = val.data;
      this.data.invoices = val.invoices;
      const nomorNotaList = [
        ...new Set((val.invoices || []).map(item => item.nomor_nota).filter(Boolean))
      ];
      this.items.nota = nomorNotaList;
      if (this.items.nota.length > 0) {
        this.claimFormData.nomor_nota = this.claimFormData.nomor_nota || this.items.nota[0];
      }

      if (val.data.ditagih_kepada != "") {
        this.state.disable_change_customer = true;
      }

      // set subtotal
      val.invoices.forEach(invoice => {
        if (invoice.lunas == "Y") {
          this.subtotal +=
            Math.abs(invoice.i_total) +
            Math.abs(invoice.ii_total) +
            Math.abs(invoice.biaya_lain_total);
        }
      });

      this.fetchClaim();
      this.fetchGiro();

      if ((!val.invoices || val.invoices.length === 0) && this.formData.ditagih_kepada) {
        this.fetchNota();
      }
    },
    formatForm() {
      this.haveNomorNota = false;
      this.subtotal = 0;

      this.formData = {
        i_total: 0,
        ii_total: 0,
        biaya_lain_total: 0,
        customer: {
          nama: ""
        },
        kolektor: {
          user_id: ""
        },
        keterangan_pelunasan: "",
        invoice_detil: []
      };

      this.state.disable_change_customer = false;

      this.data.claims = [];
      this.data.giros = [];
      this.data.invoices = [];
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    },
    formatDate(data) {
      if (!data) return "";
      let date = new Date(data);
      if (Number.isNaN(date.getTime())) return "";
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    }
  },
  created() {
    this.fetchKolektor();
    this.fetchCustomers();
    this.fetchKategoriClaim();
  }
};
</script>

<style scoped>
.invoice-item {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}

.overflow-auto {
  overflow: auto !important;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
}

.header .left {
  border: 1px solid black;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.right .border {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
}

.right .border-dotted {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
  border-style: dashed;
}

.detail-table {
  width: 100%;
  font-size: 1rem;
}

.detail-table tr td {
  padding: 2px;
}

.btn-delete {
  bottom: 80px;
}

th {
  text-align: left;
}

#section-print {
  display: none;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}
</style>
